<script setup lang="ts">
import type { SubmitPreparedOrganizationMemberTask } from "@/model/app/submit-prepared-organization-member-task"
import DeleteMember from "@/pages/App/OrganizationMember/PersonActionsWizard/actions/DeleteMember.vue"
import ReviewPreparation from "@/pages/App/OrganizationMember/PersonActionsWizard/actions/ReviewPreparation.vue"
import { defineTranslations } from "@/utils/defineTranslations"
import type { TasksProps } from "./tasks-props"

const props = defineProps<TasksProps<SubmitPreparedOrganizationMemberTask>>()
const emit = defineEmits<{
    (e: "updated"): void
}>()

const trans = defineTranslations({
    description: {
        de: "{name} hat die Rahmenvereinbarung über einen Einladungslink hinterlegt. Prüfe das Dokument und reiche das Mitglied zur Prüfung ein.",
        en: "{name} has submitted the framework agreement through an invitation link. Check the document and submit the member for review.",
    },
    closed: {
        de: "{name} wurde zur Prüfung eingereicht.",
        en: "{name} has been submitted for review.",
    },
    canceled: {
        de: "{name} wurde gelöscht und muss nicht mehr eingereicht werden.",
        en: "{name} has been deleted and doesn't need to be submitted anymore.",
    },
})
</script>

<template>
    <div class="p-4">
        <template v-if="props.task.state === 'open' && props.task.organizationMemberId">
            <p>{{ trans("description", { name: props.task.memberName }) }}</p>
            <ReviewPreparation :account-id="props.task.organizationMemberId" @done="emit('updated')">
                <template #afterSubmit>
                    <!-- deleting the member cancels this task on the server -->
                    <DeleteMember class="mt-5" :account-id="props.task.organizationMemberId" @done="emit('updated')" />
                </template>
            </ReviewPreparation>
        </template>
        <p v-else-if="props.task.state === 'canceled'" class="mb-0">
            {{ trans("canceled", { name: props.task.memberName }) }}
        </p>
        <p v-else class="mb-0">{{ trans("closed", { name: props.task.memberName }) }}</p>
    </div>
</template>
